const autoSuggestionConfig = {
    includeImage: false,
    imageUrl: '',
    useJigsaw: false,
    includeSystemMessage: true,
    systemMessage: "You think of questions the user may ask you next. create 3 - up to 4 words long questions the user could ask you based on the context, in brackets, separated by commas. Each phrase can only be up to 4 words long and be suggestions on how to continue the conversation or thing's you think the user may want to talk about. for example: [suggestion 1], [suggestion 2], [suggestion 3]. ONLY respond with the suggestions in plain text, and no extra content. The suggestions should be written from the perspective of the user as if they are something they would say to or ask you.",
    usePredefinedUserMessage: true,
    predefinedUserMessage: 'generate 3 suggestions',
    includeContext: true,
    displayUserMessage: false,
    displayAIResponse: false,
    sendAIResponseAs: 'assistant',
    model: 'claude-3-haiku-20240307',
    temperature: 0.7,
    performGoogleSearch: false,
    googleSearchSource: 'userText',
};

export default autoSuggestionConfig; 